// External
import React, { Component } from 'react'
import 'moment/locale/da'
import 'react-datepicker/dist/react-datepicker.css'

// Custom components
import Container from './components/ContainerComponent'
import Tabs from './components/TabsComponent'
import Tab from './components/TabComponent'
import TabCount from './components/TabCountComponent'
import TabText from './components/TabTextComponent'
import Content from './components/ContentComponent'

// Steps
import StepOne from './components/steps/StepOneComponent'
import StepTwo from './components/steps/StepTwoComponent'
import StepThree from './components/steps/StepThreeComponent'
import StepFour from './components/steps/StepFourComponent'

const tabs = [
    { step: 1, title: 'Vælg boks' },
    { step: 2, title: 'Vælg startdato' },
    { step: 3, title: 'Bekræft' }
]

class Booking extends Component {
    constructor(props) {
        super(props)

        this.state = {
            step: 1,
            selectedRoom: {},
            startDate: undefined,
            termsAccepted: false,
            booking: {},
            order: {
                customer: {},
                order: {},
                card: {},
                startDate: undefined,
                confirmed: false
            }
        }
    }

    onSelectTab = step => {
        if (this.isTabAvailable(step)) {
            this.setState({ step })
        }
    }

    onSelectRoom = selectedRoom => this.setState({ step: 2, selectedRoom })
    onChangeDate = startDate => this.setState({ step: 3, startDate })
    onPaymentComplete = order => this.setState({ step: 4, order })

    isTabAvailable = step => {
        if (
            step === 1 ||
            (step === 2 && this.state.selectedRoom.resource_id !== undefined) ||
            (step === 3 &&
                this.state.selectedRoom.id !== undefined &&
                this.state.startDate !== undefined)
        ) {
            return true
        } else {
            return false
        }
    }

    render() {
        const { step } = this.state

        return (
            <Container>
                <Tabs>
                    {tabs.map(tab => {
                        const active =
                            step === tab.step || (step === 4 && tab.step === 3)
                        return (
                            <Tab
                                key={tab.step}
                                isTabAvailable={this.isTabAvailable(tab.step)}
                                active={active}
                                onClick={() => this.onSelectTab(tab.step)}
                            >
                                <TabCount active={active}>{tab.step}</TabCount>
                                <TabText active={active}>{tab.title}</TabText>
                            </Tab>
                        )
                    })}
                </Tabs>
                <Content>
                    {step === 1 && this.renderStepOne()}
                    {step === 2 && this.renderStepTwo()}
                    {step === 3 && this.renderStepThree()}
                    {step === 4 && this.renderStepFour()}
                </Content>
                {/* <Content>
          <form onSubmit={this.deleteBookings}>
            <input name="bookings" type="text"/>
            <input type="submit" value="Slet"/>
          </form>
        </Content> */}
            </Container>
        )
    }

    renderStepOne() {
        let { rooms } = this.state

        return <StepOne location_id={this.props.location_id} rooms={rooms} onSelectRoom={this.onSelectRoom} />
    }

    renderStepTwo() {
        let { selectedRoom, startDate } = this.state

        return (
            <StepTwo
                selectedRoom={selectedRoom}
                startDate={startDate}
                onChangeDate={this.onChangeDate}
            />
        )
    }

    renderStepThree() {
        return (
            <StepThree
                startDate={this.state.startDate}
                selectedRoom={this.state.selectedRoom}
                onPaymentComplete={this.onPaymentComplete}
                config={this.props.config}
            />
        )
    }

    renderStepFour() {
        return <StepFour order={this.state.order} />
    }
}

export default Booking 



// WEBPACK FOOTER //
// ./src/Booking.js